import React from "react";
import ReactDOM from "react-dom/client";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home/home";
import Login from "./components/Login/login";
import Register from "./components/Register/register";
import Customer from "./components/Customer/customer";
import VendorList from "./components/Vendor/VendorList/VendorList";
import Proposal from "./components/Proposal/proposal";
import InvoiceHeader from "./components/InvoiceHeader/invoiceHeader";
import CustomerListView from "./components/CustomerListView/customerlistview";
import ProposalListView from "./components/ProposalListView/proplistview";
import InvoiceListView from "./components/InvoiceListView/invoicelistview";
import Admin from "./components/Admin/admin";
import RoleManagementPage from "./components/RoleManagement/rolemanagement";
import VendorCost from "./components/Vendor/VendorCost/VendorCost";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="home" element={<Home />} />
      <Route path="proposal" element={<Proposal />} />
      <Route path="invoiceHeader" element={<InvoiceHeader />} />
      <Route path="customerlistview" element={<CustomerListView />} />
      <Route path="proplistview" element={<ProposalListView />} />
      <Route path="invoicelistview" element={<InvoiceListView />} />
      <Route path="admin" element={<Admin />} />
      <Route path="rolemanagement" element={<RoleManagementPage />} />
      <Route path="vendorlist" element={<VendorList />} />
      <Route path="vendorcost" element={<VendorCost />} />
    </Routes>
  </BrowserRouter>
);
